import React from 'react';
import styles from './Podium.module.css';

import podium1Image from './../../assets/images/podium1.jpg';
import podium2Image from './../../assets/images/podium2.jpg';
import podium3Image from './../../assets/images/podium3.jpg';


const Podium = ({ winners }) => {
    return (
        <div className={styles.podiumContainer}>
            {winners.map(winner => (
                <div key={winner.place} className={styles.podiumStep}>
                    <img src={winner.place === 1 ? podium1Image : winner.place === 2 ? podium2Image : podium3Image} alt={`Place ${winner.place}`} />
                    <div className={styles.winnerName}>
                        {winner.name.split('&').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br/>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};


export default Podium;
